import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import { makeStyles } from "@material-ui/core/styles";
import {Grid, Tooltip} from "@material-ui/core";
import _ from "underscore";

import { CurrencyValue } from "../../../controls";

import { useFuelFees } from "../../../services/fuel";
import FuelToolTipStyles from "../styles/FuelToolTipStyles";

const FeeTooltip = (props) => {
  const { fuelRateUuid, groupType } = props;

  const [load, setLoad] = useState("WAIT");
  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const fuelFees = useFuelFees({ queryClient, extraKeys: [load==="WAIT"?"dummy":fuelRateUuid], useCache: load });

  const classes = makeStyles(FuelToolTipStyles)();

  let toolTipText = "Retrieving info...";

  const loadData = () => {
    if (load === "WAIT") {
      console.log('wowser');      
      setLoad(true);
    }
  }

  if (fuelFees.error) {
    toolTipText = "Error Retrieving info...";
  } 
  if (fuelFees.data) {
    const rows = _.where(fuelFees.data, { groupType });
    if (rows) {
      toolTipText = (
        <Fragment>
          <div style={{ fontWeight: 1000 }}>Price Breakdown</div>
          {
            rows.map((row, i) => {
              if (groupType === "DIFFERENTIAL") {
                return (
                  <Grid item xs={12} nowrap="true" key={i} style={{ minWidth: 80, textAlign: "right" }}>
                    <CurrencyValue
                      decimalScale={3}
                      fixedDecimalScale={true}
                      currencyCode={row.currencyCode}
                      value={row.amount}
                    /><span style={{width:60, display: "inline"}}>&nbsp;{row.priceUom ? `/ ${row.priceUom}` : ""}</span>
                  </Grid>
                )
              } else if (groupType === "FIXED") {
                return (
                  <Grid container nowrap="true" key={i}>
                    <Grid item xs={7} nowrap="true" style={{ minWidth: 160 }}><div style={{ display: "inline-block", minWidth: 45 }}>({row.type})</div><div style={{ display: "inline-block", width: 115, textOverflow: "ellipsis" }}>{row.name}</div></Grid>
                    <Grid item xs={5} nowrap="true" style={{ minWidth: 80, textAlign: "right" }}>
                      <CurrencyValue
                        decimalScale={2}
                        fixedDecimalScale={true}
                        currencyCode={row.currencyCode}
                        value={row.amount}
                      />
                    </Grid>
                  </Grid>
                )
              } else {
                return (
                  <Grid container nowrap="true" key={i}>
                    <Grid item xs={7} nowrap="true" style={{ minWidth: 160 }}><div style={{ display: "inline-block", minWidth: 45 }}>({row.type})</div><div style={{ display: "inline-block", width: 115, textOverflow: "ellipsis" }}>{row.name}</div></Grid>
                    <Grid item xs={5} nowrap="true" style={{ minWidth: 80, textAlign: "right" }}>
                      <CurrencyValue
                        decimalScale={3}
                        fixedDecimalScale={true}
                        currencyCode={row.currencyCode}
                        value={row.amount}
                      /><div style={{width: 90, minWidth:90, display: "inline"}}>&nbsp;{row.priceUom ? `/ ${row.priceUom}` : ""}</div>
                    </Grid>
                  </Grid>
                )
              }
            })
          }
        </Fragment >
      );
    } else {
      toolTipText = "";
    }
  };

  return (
    <Tooltip onOpen={loadData}
      classes={{ tooltip: classes.priceTooltip }} 
      placement="top-start"
      title={toolTipText}
    >
      {props.children}
    </Tooltip>
  );
}

export default FeeTooltip;